// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contain {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

@media (min-width: 768px) {
  .contain {
    flex-direction: row;
  }
}

.main-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.form-containerReferral {
  max-width: 600px;
  margin: 50px auto;
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  /* margin-top: 200px; */
}

.form-container h2 {
  margin-top: 0;
  text-align: center;
}

.form-group1 {
  margin-bottom: 15px;
  width: 300px;
}

.form-group1 label {
  display: block;
  margin-bottom: 5px;
}

.form-group1 input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
}

.update-details1 {
  padding: 10px;
  width: 200px;
  margin: 10px 0px 0px 50px;
  background-color: #2865aa;
  border: none;
  color: white;
  cursor: pointer;
  border-radius: 5px;
}

.update-details1:hover {
  -webkit-text-fill-color: black;
  background-color: #5390d9;
}
.form-group11 {
  height: 40px;
  margin-bottom: 15px;
  width: 300px;
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .contain {
    align-items: center;
    justify-content: center;
  }

  .name{
    display: none;
  }

  .form-containerReferral {
    max-width: 600px;
    margin: 50px auto;
    background-color: #f9f9f9;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    /* margin-top: 130px; */
  }
  .form-group1 input,
  .form-group11 {
    /* padding: 10px;
      margin: 5px 0;
      width: 100%;
      border: 1px solid #ccc;
      border-radius: 5px; */
    width: 100%;
    /* text-align: center; */
  }

  .update-details1 {
    width: 100%;
  }

  .form-group input {
    width: 100%;
  }
}

.form-group11 {
  height: 40px;
  margin-bottom: 15px;
  width: 300px;
  /* width: 100%; */
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
  /* background-color: #bbc2f2;  */
}

.form-group111 {
  height: 40px;
  margin-bottom: 15px;
  width: 500px;
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
}

.button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th,
td {
  padding: 8px 12px;
  border: 1px solid #ccc;
  text-align: center;
}

button {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}

/* Example styling for form inputs */
.form-group1 input {
  padding: 10px;
  margin: 5px 0;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 5px;
}

/* button.update-details1 {
    background-color: #4CAF50;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  } */

/* button.update-details1:hover {
    background-color: #45a049;
  } */
`, "",{"version":3,"sources":["webpack://./src/AddReferral.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,uCAAuC;IACvC,uBAAuB;EACzB;EACA;;IAEE;;;;2BAIuB;IACvB,WAAW;IACX,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;;;;;KAOK;;AAEL;;KAEK","sourcesContent":[".contain {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n@media (min-width: 768px) {\n  .contain {\n    flex-direction: row;\n  }\n}\n\n.main-content {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.form-containerReferral {\n  max-width: 600px;\n  margin: 50px auto;\n  background-color: #f9f9f9;\n  padding: 20px;\n  border-radius: 5px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  /* margin-top: 200px; */\n}\n\n.form-container h2 {\n  margin-top: 0;\n  text-align: center;\n}\n\n.form-group1 {\n  margin-bottom: 15px;\n  width: 300px;\n}\n\n.form-group1 label {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.form-group1 input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-sizing: border-box;\n}\n\n.update-details1 {\n  padding: 10px;\n  width: 200px;\n  margin: 10px 0px 0px 50px;\n  background-color: #2865aa;\n  border: none;\n  color: white;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.update-details1:hover {\n  -webkit-text-fill-color: black;\n  background-color: #5390d9;\n}\n.form-group11 {\n  height: 40px;\n  margin-bottom: 15px;\n  width: 300px;\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-sizing: border-box;\n}\n\n@media (max-width: 768px) {\n  .contain {\n    align-items: center;\n    justify-content: center;\n  }\n\n  .name{\n    display: none;\n  }\n\n  .form-containerReferral {\n    max-width: 600px;\n    margin: 50px auto;\n    background-color: #f9f9f9;\n    padding: 20px;\n    border-radius: 5px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    /* margin-top: 130px; */\n  }\n  .form-group1 input,\n  .form-group11 {\n    /* padding: 10px;\n      margin: 5px 0;\n      width: 100%;\n      border: 1px solid #ccc;\n      border-radius: 5px; */\n    width: 100%;\n    /* text-align: center; */\n  }\n\n  .update-details1 {\n    width: 100%;\n  }\n\n  .form-group input {\n    width: 100%;\n  }\n}\n\n.form-group11 {\n  height: 40px;\n  margin-bottom: 15px;\n  width: 300px;\n  /* width: 100%; */\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-sizing: border-box;\n  /* background-color: #bbc2f2;  */\n}\n\n.form-group111 {\n  height: 40px;\n  margin-bottom: 15px;\n  width: 500px;\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-sizing: border-box;\n}\n\n.button-wrapper {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 10px;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n\nth,\ntd {\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  text-align: center;\n}\n\nbutton {\n  padding: 10px 20px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\nbutton:hover {\n  background-color: #0056b3;\n}\n\n/* Example styling for form inputs */\n.form-group1 input {\n  padding: 10px;\n  margin: 5px 0;\n  width: 100%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n/* button.update-details1 {\n    background-color: #4CAF50;\n    color: white;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n  } */\n\n/* button.update-details1:hover {\n    background-color: #45a049;\n  } */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
